import React from 'react';
import PropTypes from 'prop-types';
import LoginController from '../controllers/LoginController';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import LoadingButton from '../components/LoadingButton';
import AvatarPage from './AvatarPage';

const styles = (theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
    }
});

/**
 * Página de login. Realiza a autenticação do usuário e redireciona para o menu principal
 */
class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        //Controlares
        this.loginController = new LoginController();
        //Estado inicial
        this.state = {
            senha: '',
            confirmacao: '',
            mensagem: '',
            carregando: false
        };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Executa quando o form é submetido.
     * @param {*} event Objeto contendo os dados do evento
     */
    async handleSubmit(event) {
        //Impede a propagação do evento
        event.preventDefault();
        this.setState({ carregando: true });
        //Cria uma cópia do estado atual
        const state = Object.assign({}, this.state);
        state.carregando = false;
        //Executa o login
        const result = await this.loginController.redefinirSenha(this.getToken(), this.state.senha, this.state.confirmacao);
        if (!result.sucesso) {
            //Caso tenha ocorrido um erro durante o login, define a mensagem
            state.mensagem = result.mensagem;
        } else {
            //Caso contrário, exibe a mensagem que a senha foi redefinida
            state.mensagem = 'A senha foi alterada, volte para a página de login para entrar na plataforma';
        }
        //Atualiza o estado
        this.setState(state);
    }

    /**
     * Recupera o token para redefinição de senha
     */
    getToken() {
        let token;
        if (this.props.match)
            token = this.props.match.params.token;
        return token;
    }

    render() {
        const { classes } = this.props;
        const { senha, confirmacao, mensagem } = this.state;
        return (
            <AvatarPage>
                <Typography component="h1" variant="h5">Informe um nova senha</Typography>
                <form onSubmit={this.handleSubmit} >
                    <Grid container>
                        <Grid item xs={12} >
                            <TextField
                                name="senha" 
                                label="Nova senha" 
                                type="password" 
                                required
                                variant="outlined" 
                                margin="normal" 
                                fullWidth 
                                value={senha} 
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <TextField
                                name="confirmacao" 
                                label="Confirmação" 
                                type="password" 
                                required
                                variant="outlined" 
                                margin="normal" 
                                fullWidth 
                                value={confirmacao} 
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <Typography id="error-message">{mensagem}</Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <LoadingButton 
                                fullWidth 
                                variant="contained" 
                                color="primary" 
                                type="submit"
                                className={classes.submit} 
                                loading={this.state.carregando}
                            >
                                Redefinir senha
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} >
                            <Button 
                                variant="text" 
                                color="default" 
                                component={Link}
                                to="/login"
                            >
                                Fazer login
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </AvatarPage>
        );
    }
}

LoginPage.propTypes = {
    /** Classes CSS utilizadas pela página */
    classes: PropTypes.shape({
        paper: PropTypes.any,
        avatar: PropTypes.any,
        submit: PropTypes.any
    }),
    /** Parâmetros da URL */
    match: PropTypes.shape({
        params: PropTypes.shape({
            /** Token para redefinição de senha */
            token: PropTypes.string
        })
    })
};

export default withStyles(styles)(LoginPage);